import { useEffect } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";

import { Stack } from "@mui/system";

import store from "../../mobx";

import { NavRail } from "../../components/NavRail";
import { MixQuickProductCard } from "./MixQuickProductCard";
import { Footer } from "../../components/Footer";
import { ReactTyped, Typed } from "react-typed";

const BG_COLOR = "#080d17";
const CLOSE_TO_BLACK = "#04060b";

export default observer(function LandingPage() {
  const { isPhone } = store.mediaBreakpointStore;

  useEffect(() => {
    store.appBarStore.set.hidden(true);
    return () => store.appBarStore.set.hidden(false);
  }, []);

  return (
    <Stack
      sx={{
        bgcolor: "rgb(255, 255, 255, 0.2)",
        width: "100vw",
        overflowX: "hidden",
        overflowY: "scroll",
      }}
    >
      <NavRail />

      <Section
        sx={{
          height: "100vh",
          width: "100vw",
          bgcolor: BG_COLOR,
          // background: `linear-gradient(to left, ${BG_COLOR}, ${BG_COLOR}, ${BG_COLOR}, ${CLOSE_TO_BLACK})`,
          backgroundImage: `url('main_background5.jpg')`,
        }}
      >
        <Box mt={12} />
        <Typography
          paragraph
          textAlign="center"
          variant="h4"
          fontFamily="Roboto"
          color="#ccc"
        >
          Licenses
        </Typography>

        <Box mt={4} />
        <MixQuickProductCard />
      </Section>
      <Footer />
    </Stack>
  );
});

function Section({ children, ...props }) {
  return <Box {...props}>{children}</Box>;
}
